define('app/views/search_suggestion_view',['app/setup', 'jquery.autocomplete'], function(takhfifan) {

  takhfifan.searchSuggestionView = takhfifan.BaseView.extend({

    initialize: function () {

      //$( "#search" ).autocomplete({
      //  serviceUrl: '/catalogsearch/ajax/suggest',
      //  paramName: 'q',
      //  onSelect: function (suggestion) {
      //    $(this).closest('form').submit();
      //  }
      //});

    },

  });
});


